import loginDirective from './login.directive';
import loginService from './login.service';

angular.module('login', [])
.directive('loginDialog', loginDirective)
.service('loginService', loginService);
